<template>
    <div class="append">
        <component
            v-for="(component, index) in components"
            :key="component.id"
            :blocked="component.blocked"
            :index="index"
            :errors="errors"
            :email="component.email"
            :notification="component.notification"
            :is="component.component"
            :categories="categories"
            :original-count="originalCount"
            @destroy-contact="destroyContact"
        />

        <div class="form-group row">
            <div class="col-md-12 m-b-sm">
                <button type="button" class="btn btn-primary btn-sm m-l-xs" @click="addContact()" v-if="canAdd()">
                    <i class="fa fa-plus"></i> {{ __('add_new') }}
                </button>
            </div>
        </div>
    </div>

</template>

<script>

import ServiceAlertContact from "./ServiceAlertContact";
import axios from "axios";

export default {
    name: "ServiceAlertSection",
    components: {
        ServiceAlertContact
    },
    data() {
        return {
            components: [],
            originalCount: 0,
        }
    },
    props: {
        old: {
            default: () => ({})
        },
        categories: {
            type: Object,
            required: true,
        },
        contacts: {
            type: Object,
            required: true,
        },
        errors: {
            type: Object,
            required: false,
        }
    },
    methods: {
        addContact() {
            if (this.canAdd()) {
                this.components.push({
                    id: (new Date()).getTime(),
                    component: ServiceAlertContact,
                    email: null,
                    notification: null,
                    blocked: false,
                })
            }
        },
        canAdd() {
            return this.components.length < 10;
        },
        destroyContact(index, email) {
            const _this = this
            const _axios = axios;
            if (email !== null) {
                swal({
                    title: $.i18n._('delete_element_?'),
                    text: $.i18n._('it_will_not_be_possible_to_retrieve_it_later_!'),
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: $.i18n._('delete'),
                    cancelButtonText: $.i18n._('cancel'),
                    closeOnConfirm: true
                }, function () {
                    if ((_this.components[index].email !== null) && index <= _this.originalCount) {
                        _axios.post('superadmin/service-alert/destroy-email', {
                            email: email,
                        })
                            .then(function (response) {
                            })
                    }
                    _this.$delete(_this.components, index)
                });
            } else {
                _this.$delete(_this.components, index)
            }
        },
    },
    created() {
        if (this.contacts) {
            for (var key of Object.keys(this.contacts)) {
                this.components.push({
                    id: (new Date()).getTime() + key,
                    component: ServiceAlertContact,
                    email: key,
                    notification: this.contacts[key],
                    blocked: true
                })
            }
            this.originalCount = this.components.length
        }
        if (this.old) {
            for (var key of Object.keys(this.old)) {
                if (key == 'email') {
                    for (var item of this.old[key]) {
                        this.components.push({
                            id: (new Date()).getTime() + Math.random(1, 999),
                            component: ServiceAlertContact,
                            email: item,
                            notification: this.old['types'] !== undefined ? this.old['types'][this.components.length] : null,
                            blocked: false
                        })
                    }
                }
            }
        }
    },
}
</script>

<style module>

</style>
